import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from 'ThemeContext';
import TitleImages from 'components/TitleImages';
import {
  Wrapper,
  Container,
  Box,
  Item,
  Imagebox,
  Image,
  Text,
  MoreLink
} from './GalleriesGrid.style';
import Title from 'components/Title';
import { AppSettingsContext } from 'AppSettingsContext';
import srcCrop from 'helpers/srcCrop';
import Bear from 'assets/Images/bear.svg';
import IMAGE_PLACEHOLDER from 'assets/Images/placeholder-364x248.png';

function WidgetGalleriesGrid({
  title = '',
  titleColor = undefined,
  titleBackground = undefined,
  linkBackground = undefined,
  linkColor = undefined,
  linkText = '',
  slug = '',

  data = []
}) {
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);

  return (
    <Wrapper>
      <Container>
        {appSettings.theme === 4 ? (
          <TitleImages
            title={title}
            titleColor={titleColor}
            titleBackground={titleBackground}
            imageSrc={Bear}
            theme={theme.title}
          />
        ) : (
          <Title
            title={title}
            titleColor={titleColor}
            titleBackground={titleBackground}
            linkBackground={linkBackground}
            linkColor={linkColor}
            linkText={linkText}
            slug={appSettings.theme === 6 ? '' : slug}
          />
        )}

        <Box theme={theme.galleriesGrid.box}>
          {data &&
            data.map((item, index) => (
              <Item key={index} to={item.slug}>
                <Imagebox theme={theme.galleriesGrid.imagebox}>
                  <Image
                    src={
                      item.image
                        ? srcCrop(item.image, { width: 364, height: 248 })
                        : IMAGE_PLACEHOLDER
                    }
                    alt={item.title}
                  />
                </Imagebox>
                <Text theme={theme.galleriesGrid.text}>{item.title}</Text>
              </Item>
            ))}
        </Box>
      </Container>
      {appSettings.theme === 6 && slug ? (
        <MoreLink
          to={slug}
          linkBackground={linkBackground}
          linkColor={linkColor}
          theme={theme.title.link}
        >
          {linkText ? linkText : <FormattedMessage id='TITLE.ALL_GALLERIES' />}
        </MoreLink>
      ) : (
        ''
      )}
    </Wrapper>
  );
}

export default WidgetGalleriesGrid;
